import { render, staticRenderFns } from "./politicsProjectManage.vue?vue&type=template&id=d0134e2a&scoped=true"
import script from "./politicsProjectManage.vue?vue&type=script&lang=js"
export * from "./politicsProjectManage.vue?vue&type=script&lang=js"
import style0 from "./politicsProjectManage.vue?vue&type=style&index=0&id=d0134e2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0134e2a",
  null
  
)

export default component.exports